// Every component a show document can reference, by stable name. Keys are explicit strings because
// production builds minify function names (element.type.name is useless there).
import {GetReady, InstructionsScene, TextScene} from "../common/text";
import {
    OperatorActionButton,
    OperatorAllegedlyTrueStatus,
    OperatorFakeBattleForm,
    OperatorInitGroup,
    OperatorMakeItADanceAssignment,
    OperatorPanel,
    OperatorProgressCount,
    OperatorReadyStatus,
    OperatorTrilemmaStats,
} from "../common/operator";
import {CharacterCreator} from "../games/character_creator/creator";
import {CharacterReady} from "../games/character_creator/character_ready";
import {DisplayMindReadCard} from "../games/mind_read/mind-read";
import {ChaosCharacters, ChaosCharactersInstructions, ChaosCharactersTitle, Grade} from "../games/chaos_characters/chaos";
import {Chat} from "../games/chat/chat";
import {CoachPlayer, DanceRoutineStep, FullDanceRoutine, GenerateDanceRoutine} from "../games/dance_routine/routine";
import {
    AlmostReady,
    Blank,
    EventWelcome,
    GetReadyDisplay,
    JFD3Title,
    PartyTechLogo,
    Sizzler,
    TitleCard,
    TitleVideo
} from "../common/title";
import {Dancelestrations, ShowDancelestrations} from "../games/dancelestrations/dancelestrations";
import {DancelestrationsScores} from "../games/dancelestrations/scores";
import {DevilsBargain} from "../games/devils_bargain/bargain";
import {DanceText, MakeItADanceRainbow, MakeItADanceRGB} from "../games/make_it_a_dance/make";
import {GetDownStories, WeGetDown, WeGetDownChorus} from "../games/we_get_down/get_down";
import {Ending} from "../common/ending";
import {AiDialog, ReceivingTransmission} from "../games/ai/ai";
import {ChaosCharactersScores, DancelestrationsHighScores, TrilemmaScores} from "../common/scores";
import {Trilemma} from "../games/trilemma/trilemma";
import {Leaderboard, PrepareLeaderboard} from "../games/leaderboard/leaderboard";
import {AllegedlyTrue} from "../games/allegedly_true/allegedly_true";
import {Ready} from "../games/ready/ready";

export const REGISTRY = {
    // scenes
    AiDialog, AllegedlyTrue, AlmostReady, Blank, ChaosCharacters, ChaosCharactersInstructions,
    ChaosCharactersScores, ChaosCharactersTitle, CharacterCreator, CharacterReady, Chat, CoachPlayer,
    DanceRoutineStep, DanceText, Dancelestrations, DancelestrationsHighScores, DancelestrationsScores,
    DevilsBargain, DisplayMindReadCard, Ending, EventWelcome, FullDanceRoutine, GenerateDanceRoutine,
    GetDownStories, GetReady, GetReadyDisplay, Grade, InstructionsScene, JFD3Title, Leaderboard,
    MakeItADanceRGB, MakeItADanceRainbow, PartyTechLogo, PrepareLeaderboard, Ready,
    ReceivingTransmission, ShowDancelestrations, Sizzler, TextScene, TitleCard, TitleVideo,
    Trilemma, TrilemmaScores, WeGetDown, WeGetDownChorus,
    // operator controls
    OperatorActionButton, OperatorAllegedlyTrueStatus, OperatorFakeBattleForm, OperatorInitGroup,
    OperatorMakeItADanceAssignment, OperatorPanel, OperatorProgressCount, OperatorReadyStatus,
    OperatorTrilemmaStats,
};

const NAME_OF = new Map(Object.entries(REGISTRY).map(([name, component]) => [component, name]));
export const nameOf = (component) => NAME_OF.get(component);
